import React from "react";
import { SingleAuthorTemplate } from "../single-author";
import { getAuthorNameKeyword, getStoryPubKeyword } from "../utils";

import "./hero-priority-single-author.m.css";

export function HeroPrioritySingleAuthorTemplate(props) {
  const photoPriorityPropsObj = Object.assign({}, props, {
    authorNameKeyword: getAuthorNameKeyword(),
    storyPubKeyword: getStoryPubKeyword(),
    hideImage: true
  });

  return (
    <div styleName="hero-priority">
      <SingleAuthorTemplate {...photoPriorityPropsObj} />
    </div>
  );
}
